import appStore from '../assets/img/DownloadOnAppStore.svg';

export const DownloadOnAppStore = () => {
    return (
        <a className='w-full box-border bg-osBlack rounded-[18px] p-3 flex items-center justify-center max-h-[60px]' href="https://apps.apple.com/us/app/obsessless-ocd-treatment-app/id6742539895" target="_blank">
            <img src={appStore} alt="App Store" className='w-full h-full object-contain' />
        </a>
    );
};
